import { useGitHubInstallationCallback } from '../hooks/useGitHubInstallationCallback'

/** Runs GitHub App installation callback handling app-wide (no UI). */
export default function GitHubInstallationHandler() {
  useGitHubInstallationCallback()
  return null
}
